import React, { createContext, useCallback, useEffect, useState } from "react";
import cookies from "react-cookies";
import jwt from "jsonwebtoken";
import { useLazyQuery } from "@apollo/client";
import { GET_USER } from "./requests";
import { message } from "antd";

const UserContext = createContext({});

const UserProvider = ({ children }) => {
  const [user, setUser] = useState("Loading");
  const [isLogged, setIsLogged] = useState(false);

  const [
    userQuery,
    {
      data: userData,
      error: userError,
      refetch: userRefetch,
      loading: userLoading,
    },
  ] = useLazyQuery(GET_USER);

  const getUser = useCallback(() => {
    const token = cookies.load("token");
    const tokenPayload = token ? jwt.decode(token, {}) : undefined;

    if (tokenPayload) {
      userQuery({
        variables: {
          id: tokenPayload.id,
        },
      });

      if (userError) {
        message.error("Ha habido un error cargando el perfil!");
        logout();
      }

      if (userData) {
        setUser(userData.user);
      }
    } else {
      logout();
    }
  }, [userData, userError, userQuery]);

  const logout = () => {
    cookies.remove("token");
    setUser(null);
    setIsLogged(false);
  };

  useEffect(() => {
    getUser();
  }, [getUser]);

  return (
    <UserContext.Provider
      value={{
        user,
        getUser,
        isLogged,
        setIsLogged,
        userRefetch,
        logout,
        userLoading,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export { UserContext };
export default UserProvider;
